"use client";

import { useReportWebVitals } from "next/web-vitals";

interface WebVitalMetric {
    id: string;
    name: string;
    value: number;
    rating?: "good" | "needs-improvement" | "poor";
}

export default function WebVitalsReporter() {
    useReportWebVitals((metric: WebVitalMetric) => {
        if (process.env.NODE_ENV !== "production" || typeof window === "undefined") {
            return;
        }

        const analyticsWindow = window as Window & { dataLayer?: Object[] };
        analyticsWindow.dataLayer = analyticsWindow.dataLayer || [];
        analyticsWindow.dataLayer.push({
            event: "core_web_vital",
            metric_name: metric.name,
            metric_value: metric.value,
            metric_rating: metric.rating ?? "unknown",
            metric_id: metric.id,
            page_path: window.location.pathname,
        });
    });

    return null;
}
